import * as React from 'react';

import styles from './label-spinner.scss';

export const LabelSpinner: React.FC = () => <div className={styles.spinLoader} />;
